import { render } from "./OuterDetail.vue?vue&type=template&id=8ef57fb2&scoped=true&ts=true"
import script from "./OuterDetail.vue?vue&type=script&lang=ts"
export * from "./OuterDetail.vue?vue&type=script&lang=ts"

import "./OuterDetail.vue?vue&type=style&index=0&id=8ef57fb2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef57fb2"]])

export default __exports__